import React from 'react'
import { useAuthUser } from '../auth'

export const UserStateComponent = () => {

    const { logout, getUserName } = useAuthUser();

    return <span onClick={logout}>{ getUserName()}</span>
}